import "devextreme/dist/css/dx.common.css";
import "./themes/generated/theme.base.css";
import "./themes/generated/theme.additional.css";
import "primeicons/primeicons.css";
import "react-notifications-component/dist/theme.css";
import React from "react";
import "./dx-styles.scss";
import { useAuth } from "./contexts/auth";
import { useScreenSizeClass } from "./utils/media-query";
import Content from "./Content";
import UnauthenticatedContent from "./UnauthenticatedContent";

function App() {
  const { user } = useAuth();

  if (user) {
    return <Content />;
  }

  return <UnauthenticatedContent />;
}

export default function Root() {
  const screenSizeClass = useScreenSizeClass();

  return (
    <div className={`app ${screenSizeClass}`}>
      <App />
    </div>
  );
}
